import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CompanyService } from '@core/services/administration/company/company.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ProductionResolver implements Resolve<any> {

    constructor(
        private _companyService: CompanyService,
    ) { }

    resolve(
        _: ActivatedRouteSnapshot,
        __: RouterStateSnapshot
    ): Observable<any> {
        return this._companyService.getMyCompany();
    }
}
